<template>
  <div v-loading="loading" element-loading-text="数据加载中..." >
    <el-form :model="busData" style="margin-top: 10px;" label-width="160px" :inline="true">
      <!--      头部信息-->
      <el-row style="margin-left: 5%" class="compact-form">
        <el-col :span="12">
          <el-form-item label="工作日期：" style="width: 90%" required>
            <el-date-picker type="date" v-model="busData.work_date" style="width: 100%" :disabled="disabled" @change="checkWorkDate()"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="本日总工时：" style="width: 90%" required>
            <el-input-number v-model="busData.total_hours" disabled style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <!--      工作记录配置-->
      <el-row style="font-weight:bold;margin-bottom: 10px;margin-left: 10px;"><b>工作记录：</b></el-row>
      <el-row v-for="item in itemList" :key="item.nanoid">
        <div style="border: 1px solid #d9d9d9;width: 90%;min-height: 250px;margin-bottom: 20px;margin-left: 5%">
          <div class="item-top">
            <div style="width: 40%;padding-left: 20px;font-weight: bold;" >
              序号： {{item.serial_number}}
            </div>
            <div class="actions" v-if="!disabled">
              <button v-if="item.serial_number > 1" class="item-bottom" @click="deleteItem(item.nanoid)">
                <el-icon><Delete/></el-icon>删除
              </button>
            </div>
          </div>
          <div style="width: 100%">
            <el-row style="margin-top: 5px" class="compact-form">
              <el-col :span="22" offset="1">
                <el-form-item label="工作简要：" style="width: 100%" required>
                  <el-input v-model="item.title" :disabled="disabled"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22" offset="1">
                <el-form-item label="项目名称：" style="width: 100%">
                  <el-select v-model="item.project_id" clearable :disabled="disabled">
                    <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="22" offset="1">
                <el-form-item label="工作内容：" style="width: 100%" required>
                  <el-input v-model="item.work_content" type="textarea" :autosize="{ minRows: 2, maxRows: 5}" :disabled="disabled"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" offset="1">
                <el-form-item label="进度(%)：" style="width: 100%" required>
                  <el-input-number v-model="item.progress" style="width: 100%" :precision="1" :min="0.1" :max="100" :disabled="disabled"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="11" offset="1">
                <el-form-item label="本项工时(h)：" style="width: 100%" required>
                  <el-input-number v-model="item.work_hour" style="width: 100%" :precision="1" :min="0.1" :max="24"
                                   @change="calcTotalHours" :disabled="disabled">
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="22" offset="1">
                <el-form-item label="备注：" style="width: 100%">
                  <el-input v-model="item.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5}" :disabled="disabled"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22" :offset="1" v-if="disabled">
                <div class="attachment-section">
                  <label class="attachment-label">
                    <span style="color: #f56c6c; margin-right: 5px">*</span>附件：
                  </label>
                  <div v-for="file in item.file_list" :key="file.id" class="file-row" @click="previewFile(file)">
                    <!-- 左侧：文件名 -->
                    <div class="file-info"><span class="file-icon">📄</span>{{ file.original_name }}</div>
                    <!-- 右侧：下载按钮 -->
                    <span  @click.stop="downloadFile(file.original_name,file)" class="download-link">
                      下载
                    </span>
                  </div>
                </div>
              </el-col>
              <el-col :span="22" offset="1" v-if="!disabled">
                <el-form-item label="附件：" required style="width: 100%">
                  <kf-file-upload v-model="item.file_ids" @fileChange="fileChange(item,$event)"
                                  :init-file="item.file_list" :limit="99" ></kf-file-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-row>
      <el-row v-if="!disabled">
        <el-button type="primary" plain @click="addOneItem(1)" style="margin-left: 10px">
          添加一条检验项
        </el-button>
      </el-row>
    </el-form>
    <div style="margin: 20px" v-if="!disabled">
      <el-row justify="center">
        <el-button type="primary" @click="workRecordEdit()">保存</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import {nanoid} from "nanoid";
import {Delete} from "@element-plus/icons-vue";
import {ElMessageBox} from "element-plus";

export default {
  name: "WorkRecordEdit",
  components: { Delete},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      busData: {
        item_list: []
      },
      projectList:[],
      itemList:[],
      disabled: false,
      parma:'',
      loading:true
    }
  },
  created() {
    this.getData()
    this.getProjectList();
  },
 
  methods: {

    //获取当前用户所在的项目
    async getProjectList() {
      this.projectList = await this.$http('prjWorkRecordService.getMyProjectList',this.parentData);
    },

    //检查工作日期是否已存在
    async checkWorkDate() {
      if (this.busData.work_date) {
        if (this.busData.work_date > new Date()) {
          this.busData.work_date = '';
          return this.$message.error("工作日期不能超过今天");
        }
      }
      let date = await this.$http('prjWorkRecordService.checkWorkDate', this.busData);
      if (date) {
        this.busData.work_date = '';
        return this.$message.error("该日期已存在工作记录");
      }
    },

    //获取总工时
    calcTotalHours(){
      let hours = 0;
      for (let i = 0; i < this.itemList.length; i++){
        hours += this.itemList[i].work_hour
      }
      this.busData.total_hours = hours
    },

    //获取数据
    async getData() {
      try {
        this.loading = true
        let data = this.parentData
        this.parma = this.componentParam
        this.busData = await this.$http('prjWorkRecordService.getWorkRecordDetail', data)
        this.itemList = this.busData.item_list
        for (let i = 0; i < this.itemList.length; i++){
          this.itemList[i].nanoid= nanoid()
        }
        this.disabled = this.busData.disabled
        if (this.parma === 'prj_work_record_detail'){
          this.disabled = true
        }
      } catch (error) {
        console.error('数据加载失败', error)
      } finally {
        this.loading = false // 无论成功失败都关闭加载状态
      }
    },

    //添加一行检验项
    addOneItem(cnt){
      for (let i = 0; i < cnt; i++){
        this.itemList.push({
          nanoid: nanoid(),
          serial_number: this.itemList.length + 1
        })
      }
    },

    //检验项上移
    moveUpItem(nanoid){
      for (let i = 0; i < this.itemList.length; i++){
        if (this.itemList[i].nanoid === nanoid) {
          if (i > 0) {
            let temp = this.itemList[i];
            this.itemList[i] = this.itemList[i - 1];
            this.itemList[i - 1] = temp;
            this.itemList[i].serial_number = i + 1;
            this.itemList[i - 1].serial_number = i;
            break;
          }
        }
      }
    },

    //检验项下移
    moveDownItem(nanoid){
      for (let i = 0; i < this.itemList.length; i++){
        if (this.itemList[i].nanoid === nanoid) {
          if (i < this.itemList.length - 1) {
            let temp = this.itemList[i];
            this.itemList[i] = this.itemList[i + 1];
            this.itemList[i + 1] = temp;
            this.itemList[i].serial_number = i + 1;
            this.itemList[i + 1].serial_number = i + 2 ;
            break;
          }
        }
      }
    },

    //删除检验项
    deleteItem(nanoid){
      for (let i = 0; i < this.itemList.length; i++){
        if (this.itemList[i].nanoid === nanoid) {
          this.itemList.splice(i,1);
          for (let j = i; j < this.itemList.length; j++){
            this.itemList[j].serial_number = j + 1;
          }
          this.calcTotalHours();
          return
        }
      }
    },

    //保存
    async workRecordEdit() {
      if (!this.busData.work_date) {
        return this.$message.error("请选择工作日期");
      }
      if (this.itemList.length === 1 && !this.itemList[0].title){
        return this.$message.error("请填写工作记录");
      }

      for (let i = 0; i < this.itemList.length; i++){
        if (!this.itemList[i].title) {
          this.itemList.splice(i,1);
        } else {
          if (!this.itemList[i].work_content){
            return this.$message.error("请选择第【"+ this.itemList[i].serial_number +"】项的详情内容");
          }
          if (!this.itemList[i].progress){
            return this.$message.error("请填写第【"+ this.itemList[i].serial_number +"】项的进度(%)");
          }
          if (!this.itemList[i].work_hour){
            return this.$message.error("请填写第【"+ this.itemList[i].serial_number +"】项的本项工时(h)");
          }
          if (!this.itemList[i].file_ids){
            return this.$message.error("请添加第【"+ this.itemList[i].serial_number +"】项的附件");
          }
        }
      }
      if (this.itemList.length === 0){
        return this.$message.error("请填写工作记录");
      }
      if (this.busData.total_hours > 24) {
        return this.$message.error("本日总工时已超过24小时，请修改");
      }
      for (let i = 0; i < this.itemList.length; i++){
        this.itemList[i].serial_number = i + 1;
      }
      ElMessageBox.confirm(
          '你是否确认提交工作记录表',
          '提交表单',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        this.busData.item_list = this.itemList;
        await this.$http('prjWorkRecordService.editWorkRecord', this.busData)
        this.$message.success("保存成功")
        this.$fn.closeWindow();
        this.$fn.search();
      })
    },

    fileChange(item,ids) {
      if (ids.length <= 0) {
        item.file_ids = '';
      }else {
        item.file_ids = ids;
      }
    },

    previewFile(file) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "project/ViewPdf";
      windowObj.name = file.name;
      windowObj.parentData = file;
      windowObj.height = 600 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1100 || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.no_min = true
      windowObj.max = true

      this.$store.dispatch('core/openWindow', windowObj)
    },

    //下载文件
    downloadFile(name,item){
      let url = item?.url;
      if (!url) {
        return
      }

      let baseUrl = window.location.protocol +'//'+ window.location.host + '/'
      const index = url.indexOf('fileServer');
      let newUrl = '';
      if (index !== -1) {
        newUrl = url.substring(0,index) ;
      }
      if (baseUrl !== newUrl){
        url = baseUrl + url.substring(index);
      }

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },

  }
}
</script>


<style scoped>

:deep(.el-input-number__decrease) {
  width: 20px;
}

:deep(.el-input-number__increase) {
  width: 20px;
}

:deep(.el-input-number.is-controls-right .el-input__wrapper) {
  padding: 0 20px 0 5px;
}

.item-top {
  width: 100%;
  height: 25px;
  border: 1px solid #d9d9d9;
  background-color: #e6e6e6;
  display:flex;
  justify-content: space-between;
  align-items: center
}

.actions {
  width: 60%;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.item-bottom {
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fc0202;
  background-color: #e6e6e6
}

.compact-form .el-col {
  margin-bottom: 5px;
}

.compact-form .el-form-item {
  margin-bottom: 5px;
}

.attachment-section {
  width: 100%;
  margin-bottom: 16px; /* 可选：模拟 el-form-item 的间距 */
  margin-left: 58px;
}

.attachment-label {
  display: inline-block;
  font-size: 14px;
  color: #606266;
}

/* 每一行文件的整体容器 */
.file-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  padding: 5px 0;
  margin: 5px 0 5px 65px;
  border-radius: 4px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.25s ease;
}

.file-row:hover {
  background-color: #eef5ff; /* 浅蓝色背景 */
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2); /* 微阴影 */
}

/* 文件信息（图标 + 名称） */
.file-info {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
}

.file-icon {
  margin-right: 8px;
  font-size: 16px;
}

/* 防止文字过长溢出 */
.file-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 100px); /* 给按钮留空间 */
}
.file-icon {
  margin-right: 8px;
  font-size: 12px; /* 可调整图标大小 */
}

.file-item:hover {
  color: #409eff;
  text-shadow: 0 0 2px rgba(64, 158, 255, 0.4);
}

/* 悬停时，让内部文字（含图标）变蓝 */
.file-row:hover .file-info {
  color: #409eff;
}

/* 无边框下载链接 */
.download-link {
  color: #409eff;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  padding: 2px 4px;
  border-radius: 2px;
  transition: background-color 0.2s;
}

.download-link:hover {
  background-color: rgba(64, 158, 255, 0.1);
  text-decoration: none;
}

</style>
